module.exports = __webpack_public_path__ + "static/media/ItilCert.347dd7d9.png";